import React from 'react'
import classes from './ThemeSwitch.module.scss'
import Switch from '@/components/ui/Switch'
import { Theme } from '@/config/app'
import Typography from '@/components/ui/Typography'
import { useTheme } from '@/providers/theme'

const ThemeSwitch = () => {
  const { theme, toggleTheme } = useTheme()

  return (
    <div className={classes.root}>
      <Typography variant={'sm'} isBold>
        {theme === Theme.Light ? 'Light' : 'Dark'}
      </Typography>
      <Switch checked={theme === Theme.Light} onClick={toggleTheme} />
    </div>
  )
}

export default ThemeSwitch
